package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AssistantConversationQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    skill_id: String,
    title: String?,
    created_at: Long,
    last_message_at: Long?,
    push_error: String?,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_493_449_502, arrayOf("assistant_conversation"), driver,
      "AssistantConversation.sq", "selectAll",
      "SELECT assistant_conversation.id, assistant_conversation.skill_id, assistant_conversation.title, assistant_conversation.created_at, assistant_conversation.last_message_at, assistant_conversation.push_error, assistant_conversation.updated_at, assistant_conversation.is_deleted, assistant_conversation.deleted_at, assistant_conversation.synced_at FROM assistant_conversation WHERE is_deleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectAll(): Query<Assistant_conversation> = selectAll { id, skill_id, title,
      created_at, last_message_at, push_error, updated_at, is_deleted, deleted_at, synced_at ->
    Assistant_conversation(
      id,
      skill_id,
      title,
      created_at,
      last_message_at,
      push_error,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBySkill(skill_id: String, mapper: (
    id: String,
    skill_id: String,
    title: String?,
    created_at: Long,
    last_message_at: Long?,
    push_error: String?,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectBySkillQuery(skill_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectBySkill(skill_id: String): Query<Assistant_conversation> =
      selectBySkill(skill_id) { id, skill_id_, title, created_at, last_message_at, push_error,
      updated_at, is_deleted, deleted_at, synced_at ->
    Assistant_conversation(
      id,
      skill_id_,
      title,
      created_at,
      last_message_at,
      push_error,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectTrashBySkill(
    skill_id: String,
    deleted_at: Long?,
    mapper: (
      id: String,
      skill_id: String,
      title: String?,
      created_at: Long,
      last_message_at: Long?,
      push_error: String?,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectTrashBySkillQuery(skill_id, deleted_at) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectTrashBySkill(skill_id: String, deleted_at: Long?): Query<Assistant_conversation>
      = selectTrashBySkill(skill_id, deleted_at) { id, skill_id_, title, created_at,
      last_message_at, push_error, updated_at, is_deleted, deleted_at_, synced_at ->
    Assistant_conversation(
      id,
      skill_id_,
      title,
      created_at,
      last_message_at,
      push_error,
      updated_at,
      is_deleted,
      deleted_at_,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    skill_id: String,
    title: String?,
    created_at: Long,
    last_message_at: Long?,
    push_error: String?,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectById(id: String): Query<Assistant_conversation> = selectById(id) { id_, skill_id,
      title, created_at, last_message_at, push_error, updated_at, is_deleted, deleted_at,
      synced_at ->
    Assistant_conversation(
      id_,
      skill_id,
      title,
      created_at,
      last_message_at,
      push_error,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun countLive(skill_id: String): Query<Long> = CountLiveQuery(skill_id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    skill_id: String,
    title: String?,
    created_at: Long,
    last_message_at: Long?,
    push_error: String?,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-683_203_885, arrayOf("assistant_conversation"), driver,
      "AssistantConversation.sq", "selectDirty",
      "SELECT assistant_conversation.id, assistant_conversation.skill_id, assistant_conversation.title, assistant_conversation.created_at, assistant_conversation.last_message_at, assistant_conversation.push_error, assistant_conversation.updated_at, assistant_conversation.is_deleted, assistant_conversation.deleted_at, assistant_conversation.synced_at FROM assistant_conversation WHERE (synced_at IS NULL OR synced_at < updated_at) AND push_error IS NULL") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectDirty(): Query<Assistant_conversation> = selectDirty { id, skill_id, title,
      created_at, last_message_at, push_error, updated_at, is_deleted, deleted_at, synced_at ->
    Assistant_conversation(
      id,
      skill_id,
      title,
      created_at,
      last_message_at,
      push_error,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    skill_id: String,
    title: String?,
    created_at: Long,
    last_message_at: Long?,
    push_error: String?,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getLong(3)!!,
      cursor.getLong(4),
      cursor.getString(5),
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Assistant_conversation> =
      selectByIdAnyState(id) { id_, skill_id, title, created_at, last_message_at, push_error,
      updated_at, is_deleted, deleted_at, synced_at ->
    Assistant_conversation(
      id_,
      skill_id,
      title,
      created_at,
      last_message_at,
      push_error,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    skill_id: String,
    title: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(1_111_977_468,
        """INSERT INTO assistant_conversation(id, skill_id, title, created_at, updated_at) VALUES (?, ?, ?, ?, ?)""",
        5) {
          bindString(0, id)
          bindString(1, skill_id)
          bindString(2, title)
          bindLong(3, created_at)
          bindLong(4, updated_at)
        }
    notifyQueries(1_111_977_468) { emit ->
      emit("assistant_conversation")
    }
  }

  public fun insertFromRemote(
    id: String,
    skill_id: String,
    title: String?,
    created_at: Long,
    last_message_at: Long?,
    updated_at: Long,
  ) {
    driver.execute(1_001_067_436, """
        |INSERT INTO assistant_conversation(id, skill_id, title, created_at, last_message_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?)
        """.trimMargin(), 6) {
          bindString(0, id)
          bindString(1, skill_id)
          bindString(2, title)
          bindLong(3, created_at)
          bindLong(4, last_message_at)
          bindLong(5, updated_at)
        }
    notifyQueries(1_001_067_436) { emit ->
      emit("assistant_conversation")
    }
  }

  public fun rename(
    title: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_361_175_169,
        """UPDATE assistant_conversation SET title = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, title)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_361_175_169) { emit ->
      emit("assistant_conversation")
    }
  }

  public fun updateFromRemote(
    skill_id: String,
    title: String?,
    last_message_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-500_550_212,
        """UPDATE assistant_conversation SET skill_id = ?, title = ?, last_message_at = ?, push_error = NULL, updated_at = ? WHERE id = ?""",
        5) {
          bindString(0, skill_id)
          bindString(1, title)
          bindLong(2, last_message_at)
          bindLong(3, updated_at)
          bindString(4, id)
        }
    notifyQueries(-500_550_212) { emit ->
      emit("assistant_conversation")
    }
  }

  public fun markRefused(push_error: String?, id: String) {
    driver.execute(-693_581_344,
        """UPDATE assistant_conversation SET push_error = ?, synced_at = updated_at WHERE id = ?""",
        2) {
          bindString(0, push_error)
          bindString(1, id)
        }
    notifyQueries(-693_581_344) { emit ->
      emit("assistant_conversation")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(2_008_641_592,
        """UPDATE assistant_conversation SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(2_008_641_592) { emit ->
      emit("assistant_conversation")
    }
  }

  public fun restoreFromTrash(updated_at: Long, id: String) {
    driver.execute(-1_583_667_645,
        """UPDATE assistant_conversation SET is_deleted = 0, updated_at = ? WHERE id = ? AND is_deleted = 1""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_583_667_645) { emit ->
      emit("assistant_conversation")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-748_056_661,
        """UPDATE assistant_conversation SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-748_056_661) { emit ->
      emit("assistant_conversation")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_083_432_086, """
        |UPDATE assistant_conversation
        |SET synced_at = ?,
        |    deleted_at = CASE WHEN is_deleted = 0 THEN NULL ELSE deleted_at END
        |WHERE id = ? AND updated_at <= ?
        """.trimMargin(), 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_083_432_086) { emit ->
      emit("assistant_conversation")
    }
  }

  private inner class SelectBySkillQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_conversation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_conversation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-774_787_333, """
    |SELECT assistant_conversation.id, assistant_conversation.skill_id, assistant_conversation.title, assistant_conversation.created_at, assistant_conversation.last_message_at, assistant_conversation.push_error, assistant_conversation.updated_at, assistant_conversation.is_deleted, assistant_conversation.deleted_at, assistant_conversation.synced_at FROM assistant_conversation WHERE skill_id = ? AND is_deleted = 0
    |ORDER BY coalesce(last_message_at, created_at) DESC, created_at DESC
    """.trimMargin(), mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "AssistantConversation.sq:selectBySkill"
  }

  private inner class SelectTrashBySkillQuery<out T : Any>(
    public val skill_id: String,
    public val deleted_at: Long?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_conversation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_conversation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_140_076_607,
        """SELECT assistant_conversation.id, assistant_conversation.skill_id, assistant_conversation.title, assistant_conversation.created_at, assistant_conversation.last_message_at, assistant_conversation.push_error, assistant_conversation.updated_at, assistant_conversation.is_deleted, assistant_conversation.deleted_at, assistant_conversation.synced_at FROM assistant_conversation WHERE skill_id = ? AND is_deleted = 1 AND deleted_at >= ? ORDER BY deleted_at DESC""",
        mapper, 2) {
      bindString(0, skill_id)
      bindLong(1, deleted_at)
    }

    override fun toString(): String = "AssistantConversation.sq:selectTrashBySkill"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_conversation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_conversation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(947_746_993,
        """SELECT assistant_conversation.id, assistant_conversation.skill_id, assistant_conversation.title, assistant_conversation.created_at, assistant_conversation.last_message_at, assistant_conversation.push_error, assistant_conversation.updated_at, assistant_conversation.is_deleted, assistant_conversation.deleted_at, assistant_conversation.synced_at FROM assistant_conversation WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "AssistantConversation.sq:selectById"
  }

  private inner class CountLiveQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_conversation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_conversation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_574_060_152,
        """SELECT count(*) FROM assistant_conversation WHERE skill_id = ? AND is_deleted = 0 AND push_error IS NULL""",
        mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "AssistantConversation.sq:countLive"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_conversation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_conversation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-248_362_538,
        """SELECT assistant_conversation.id, assistant_conversation.skill_id, assistant_conversation.title, assistant_conversation.created_at, assistant_conversation.last_message_at, assistant_conversation.push_error, assistant_conversation.updated_at, assistant_conversation.is_deleted, assistant_conversation.deleted_at, assistant_conversation.synced_at FROM assistant_conversation WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "AssistantConversation.sq:selectByIdAnyState"
  }
}
